import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HashLink } from "react-router-hash-link";



const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="z-20 bg-transparent backdrop-blur-md sticky top-0 shadow-lg">
      <div className="bg-transparent max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-transparent flex items-center justify-between h-16">
          <motion.div className="bg-transparent flex items-center"
          initial={{ x: -200 }}
          animate={{ x: 0,
            transition: { duration: 1.2, ease: 'easeOut' } }}
          >
            <HashLink to="/#home" className="font-bold tracking-widest text-transparent text-2xl bg-clip-text bg-gradient-to-r from-yellow-300 to-red-800 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700 ">
            &lt;𝑀𝓎 𝒫𝑜𝓇𝓉𝒻𝑜𝓁𝒾𝑜/&gt;
            </HashLink>
          </motion.div>

          {/* Mobile menu button */}
          <div className="flex md:hidden">
            <button
              onClick={toggleNavbar}
              type="button"
              className="text-white hover:text-gray-200 focus:outline-none focus:text-gray-200"
              aria-label="Toggle menu"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop menu */}
          <motion.div 
          initial={{ x: 400 }}
          animate={{ x: 0,
            transition: { duration: 1.2, ease: 'easeOut' } }}
           className="bg-transparent hidden md:flex md:justify-between md:items-center w-2/2">
            <div className="bg-transparent flex items-center justify-between space-x-10">
              <HashLink
                to="#about"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                About
              </HashLink>
              <HashLink
                to="#skill"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Skills
              </HashLink>
              
              <HashLink
                to="#experience"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Experience
              </HashLink>
              <Link
                to="/project"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Project
              </Link>
              

              <Link
                to="/contact"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Contact Me
              </Link>
              
            </div>
          </motion.div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden ">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 flex flex-col ">
            
          <Link
                to="#about"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                About
              </Link>
              <Link
                to="#skills"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Skills
              </Link>
              
              <Link
                to="#experience"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Experience
              </Link>
              <Link
                to="/project"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Project
              </Link>
              <Link
                to="/contact"
                className="font-semibold tracking-widest text-transparent text-lg bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 hover:bg-gradient-to-r hover:from-orange-400 hover:to-yellow-700"
              >
                Contact Me
              </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
